export function focus(selector) {
    let el = document.querySelector(selector);
    console.log('focus', el);
    if(el instanceof HTMLElement) {
        el.focus();
    }
}

export function stripTags(html) {
    const el = document.createElement('div');
    el.innerHTML = html;
    return el.textContent;
}
